// src/components/common/PlanDetalleCard.js
import React from 'react';
import {
  FaInfoCircle,
  FaPlayCircle,
  FaWeightHanging,
  FaExclamationTriangle,
  FaBullseye,
  FaChevronRight
} from 'react-icons/fa';

const APP_PRIMARY = '#b03060';

export default function PlanDetalleCard({ planInfo }) {
  if (!planInfo) return null;

  return (
    <div style={styles.cardContainer}>
      <div style={styles.header}>
        <div style={styles.badge}>Plan de Entrenamiento</div>
        <h3 style={styles.title}>{planInfo.titulo}</h3>
      </div>

      {/* 1. Descripción */}
      <div style={styles.section}>
        <div style={styles.sectionHeading}>
          <FaInfoCircle color={APP_PRIMARY} size={16} />
          <span>Descripción</span>
        </div>
        <p style={styles.text}>{planInfo.descripcion}</p>
      </div>

      {/* 2. ¿Cómo usar este plan? */}
      {planInfo.comoUsar && planInfo.comoUsar.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionHeading}>
            <FaPlayCircle color={APP_PRIMARY} size={16} />
            <span>¿Cómo usar este plan?</span>
          </div>
          <ul style={styles.list}>
            {planInfo.comoUsar.map((item, idx) => (
              <li key={idx} style={styles.listItem}>
                <FaChevronRight size={10} color={APP_PRIMARY} style={{ marginTop: 4, flexShrink: 0 }} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* 3. Carga de entrenamiento */}
      {planInfo.carga && planInfo.carga.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionHeading}>
            <FaWeightHanging color={APP_PRIMARY} size={16} />
            <span>Carga de entrenamiento</span>
          </div>
          <ul style={styles.list}>
            {planInfo.carga.map((item, idx) => (
              <li key={idx} style={styles.listItem}>
                <FaChevronRight size={10} color={APP_PRIMARY} style={{ marginTop: 4, flexShrink: 0 }} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* 4. Importante */}
      {planInfo.importante && planInfo.importante.length > 0 && (
        <div style={styles.importantBox}>
          <div style={styles.importantHeading}>
            <FaExclamationTriangle color="#dc2626" size={16} />
            <span>IMPORTANTE</span>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {planInfo.importante.map((item, idx) => (
              <p key={idx} style={styles.importantText}>
                {item}
              </p>
            ))}
          </div>
        </div>
      )}

      {/* 5. Objetivo del plan */}
      {planInfo.objetivos && planInfo.objetivos.length > 0 && (
        <div style={styles.section}>
          <div style={styles.sectionHeading}>
            <FaBullseye color={APP_PRIMARY} size={16} />
            <span>Objetivo del plan</span>
          </div>
          <ul style={styles.list}>
            {planInfo.objetivos.map((item, idx) => (
              <li key={idx} style={styles.listItem}>
                <div style={styles.bulletDot} />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

const styles = {
  cardContainer: {
    backgroundColor: '#ffffff',
    borderRadius: 16,
    padding: '24px',
    border: '1px solid #f1f5f9',
    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
    marginBottom: 24,
    display: 'flex',
    flexDirection: 'column',
    gap: 18
  },
  header: {
    borderBottom: '1px solid #f1f5f9',
    paddingBottom: 12
  },
  badge: {
    display: 'inline-block',
    fontSize: 11,
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.6px',
    backgroundColor: '#fdf2f8',
    color: APP_PRIMARY,
    padding: '4px 10px',
    borderRadius: 20,
    marginBottom: 6
  },
  title: {
    margin: 0,
    fontSize: 20,
    fontWeight: '700',
    color: '#1e293b'
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8
  },
  sectionHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 15,
    fontWeight: '700',
    color: '#334155'
  },
  text: {
    margin: 0,
    fontSize: 14,
    color: '#475569',
    lineHeight: 1.6
  },
  list: {
    margin: 0,
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 6
  },
  listItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    fontSize: 13.5,
    color: '#475569',
    lineHeight: 1.5
  },
  bulletDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: APP_PRIMARY,
    marginTop: 7,
    flexShrink: 0
  },
  importantBox: {
    backgroundColor: '#fff1f2',
    borderLeft: '4px solid #dc2626',
    borderRadius: 8,
    padding: '14px 16px',
    marginTop: 4
  },
  importantHeading: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontSize: 13,
    fontWeight: '800',
    color: '#dc2626',
    letterSpacing: '0.4px',
    marginBottom: 6
  },
  importantText: {
    margin: 0,
    fontSize: 13,
    color: '#881337',
    lineHeight: 1.5
  }
};